<app-option-bar [type]="'MASTERSUITE'" [details]="mastersuiteDetails" (projectwebConfigtool)="projectConfigWebTool($event)"></app-option-bar>
<div class="container-fluid details-wrapper">
  <div class="content-wrapper">
    <div class="inner-nav">
      <app-left-menu [details]="mastersuiteDetails" [type]="'MASTERSUITE'"></app-left-menu>
    </div>
    <div class="inner-content collapsed">
      <div class="no-results font-weight-bold common-section" *ngIf="!recentExecution">Please execute to fetch the results</div>
      <div *ngIf="recentExecution">
        <div class="common-section">
          <div class="common-heading">Global Status
            <small class="float-right">Execution id : {{recentExecution.execution?.noSqlId}}</small>
          </div>
          <div class="common-box">
            <div class="row">
              <div class="col-md-4 d-flex" *ngIf="!recentExecution.execution?.executionCompleted">
                <span class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" [(ngModel)]=isAutoRefresh
                    (change)="autoRefreshClick()">
                  <label class="form-check-label"> Auto Refresh</label>
                </span>
                <select [(ngModel)]="autoRefreshInterval" (change)="autoRefreshClick()">
                  <option value="5">5 Sec</option>
                  <option value="10">10 Sec</option>
                  <option value="30">30 Sec</option>
                  <option value="60">1 Min</option>
                </select>
                <a [routerLink]="" class="btn relay-btn primary"
                  (click)="getResultTSuite(recentExecution.execution.executedTaskId)"
                  [hidden]="isAutoRefresh">Refresh</a>
                <a [routerLink]="" class="btn relay-btn rejected"
                  (click)="stopMastersuiteExec(recentExecution.execution.noSqlId)">Stop</a>
                <div class="spinner-grow text-primary" role="status" *ngIf="isAutoRefresh">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div class="col-md-3">
                <label class="font-bold">Status :</label>
                {{recentExecution.execution?.executionStatus}}
              </div>
              <div class="col-md-3">
                <label class="font-bold">Start time :</label>
                {{recentExecution.execution?.startTime | localDate}}
              </div>
              <div class="col-md-3" [hidden]="!recentExecution.execution?.endTime">
                <label class="font-bold">End time :</label>
                {{recentExecution.execution?.endTime | localDate}}
              </div>
              <div class="col-md-3">
                <span class="font-bold">Time Taken : </span>
                <small>{{recentExecution?.execution?.totalExecutionTimeInSec | secondsToHms}}</small>
              </div>
              <div class="col-md-3">
                <label class="font-bold">Executed by :</label>
                {{recentExecution.execution?.executedBy}}
              </div>
              <div class="col-md-2" [hidden]="!mastersuiteDetails?.showBrowserOptions">
                <span class="font-bold">Os :</span>
                {{recentExecution.execution?.os}}
              </div>
              <div class="col-md-3" [hidden]="!mastersuiteDetails?.showBrowserOptions">
                <span class="font-bold">Browser :</span>
                {{recentExecution.execution?.browserType}}
              </div>
              <div class="col-md-3" [hidden]="!recentExecution.environmentMap">
                <span class="font-bold">Env mapper :</span>
                {{recentExecution.environmentMap?.name}}
              </div>

              <div class="w-100 d-none d-md-block mb-1"></div>

              <div class="col-md-2 text-success">
                <span class="font-bold">Passed :</span>
                {{recentExecution.passCount}}
              </div>
              <div class="col-md-2 text-danger">
                <span class="font-bold">Failed :</span>
                {{recentExecution.failedCount}}
              </div>

              <div class="col-2 text-warning">
                <span class="font-bold">Skip :</span>
                {{recentExecution.skippedCount}}
              </div>
              <div class="col-2 text-danger">
                <span class="font-bold">Relay error :</span>
                {{recentExecution.relayErrorCount}}
              </div>

            </div>
          </div>
        </div>
        <ngb-alert [type]="'danger'" *ngIf="recentExecution.execution?.exceptionOccured && !closeErrorAlert"
          (close)="closeErrorAlert = true">
          <strong>Error !</strong>
          {{recentExecution.execution.exceptionMessage}}
        </ngb-alert>
        <ngb-alert [type]="'warning'" dismissible="true" (close)="warningFlag = false"
          *ngIf="recentExecution?.execution?.warningOccured && recentExecution?.execution?.executionStatus === 'PENDING' && !recentExecution?.execution?.exceptionOccured && warningFlag && !parallelRun">
          <strong>Warning !</strong>
          {{ recentExecution?.execution?.warningMessage }}
        </ngb-alert>
        <app-suite-result [entityExecDetails]="testSuiteExecDetails" [entityType]="'MASTERSUITE'"
          [entityExecResults]="resultTsuiteExec"
          [childEntityExec]="formatChildEntity(resultTsuiteExec?.testSuiteExecutions)" [parallelRun]="parallelRun"
          [childEntityResult]="testCaseExecResult" [showPagination]="true"
          (readEntityExecution)="readTestsuiteExecution($event)"
          (readChildEntityExecution)="readTestcaseExecution($event)" (selectedPageSize)="onSizeChange($event)"
          (selectedPage)="onPageChange($event)" [projectConfiguration]="projectConfiguration"></app-suite-result>
      </div>
    </div>
  </div>
</div>